var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.922 17.4162C7.73993 17.4172 7.56166 17.3641 7.40994 17.2634C7.25821 17.1628 7.13989 17.0192 7.07007 16.851C7.00025 16.6829 6.98209 16.4977 7.01791 16.3192C7.05372 16.1407 7.14189 15.9769 7.27116 15.8487L12.1295 10.9995L7.27116 6.15035C7.09855 5.97774 7.00158 5.74363 7.00158 5.49952C7.00158 5.25541 7.09855 5.0213 7.27116 4.84869C7.44378 4.67607 7.67789 4.5791 7.922 4.5791C8.16611 4.5791 8.40022 4.67607 8.57283 4.84869L14.0728 10.3487C14.2436 10.5204 14.3394 10.7528 14.3394 10.9949C14.3394 11.2371 14.2436 11.4694 14.0728 11.6412L8.57283 17.1412C8.48793 17.2278 8.38669 17.2967 8.27497 17.3439C8.16326 17.3911 8.04328 17.4157 7.922 17.4162Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.ee609cab3638333114f7eaa0970c32ab.svg";
export { ForwardRef as ReactComponent };